enum Zoom {
  small,
  default,
  large,
  xLarge
}

export default Zoom;